const Cart = ({ cart, total, onRemove, onClose, onCheckout }) => {
  console.log("Cart Component:", cart, total);
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-end">
      <div className="bg-white w-full max-w-md h-full overflow-y-auto">
        <div className="p-4 border-b">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold">Shopping Cart</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>
        </div>
        <div className="p-4">
          {cart.length === 0 ? (
            <p className="text-gray-500">Your cart is empty.</p>
          ) : (
            <>
              <div className="space-y-4 mb-4">
                {cart.map((item, index) => (
                  <div
                    key={index}
                    className="flex justify-between items-center border-b pb-2"
                  >
                    <div>
                      <img
                        src={`../myNewAPI/${item.prod_img}`}
                        alt={item.prod_name}
                        className="w-100 h-28 object-cover rounded"
                      />
                    </div>
                    <div>
                      <p className="font-medium">{item.prod_name}</p>
                      <p className="text-gray-600">
                        PKR
                        {item.prod_price
                          ? " " +
                            new Intl.NumberFormat("en-IN").format(
                              item.prod_price,
                            )
                          : 0}
                      </p>
                      <p className="text-gray-600">Qty x {item.quantity}</p>
                    </div>

                    <button
                      onClick={() => onRemove(index)}
                      className="text-red-500 hover:text-red-700"
                    >
                      Remove
                    </button>
                  </div>
                ))}
              </div>
              <div className="border-t pt-4">
                <div className="flex justify-between items-center mb-4">
                  <span className="text-lg font-semibold">Total:</span>
                  <span className="text-lg font-bold">
                    PKR {new Intl.NumberFormat("en-IN").format(total)}
                  </span>
                </div>
                <button
                  onClick={onCheckout}
                  className="w-full bg-green-600 text-white py-3 px-4 rounded-md hover:bg-green-700 transition duration-200 font-semibold"
                >
                  Checkout
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Cart;
